import script from "./TripRow.vue?vue&type=script&setup=true&lang=ts"
export * from "./TripRow.vue?vue&type=script&setup=true&lang=ts"

import "./TripRow.vue?vue&type=style&index=0&id=52226b3f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52226b3f"]])

export default __exports__